<template>
  <div>
    <div v-if="getShowTotal()">
        <div class="tooltip" id="tooltip" v-show="isShowTool"  v-if="winValueTip !=null">
          <div class="tooltip_toast">
            <div class="tooltip_title">total:{{winValueTip}}</div>
          </div>
          <div class="icon"></div>
        </div>
      <div class="gameDetailTotal_Left">
        <div v-if="winValueTip !=null" @click="showTool()">
          <img :src="require('../../../assets/more.png')" alt="">
        </div>
      </div>
      <div v-if="winValue !=null" class="gameDetailTotal">total:{{winValue}}</div>
    </div>
  </div>
</template>
<script>
import {common_utils} from "../../common/common_utils";

export default {
    name: "SlotsWinTotalLayout",
    props: {
        showTotal:false,
        winValueTotal:null,
        Phone:false,
    },
    data() {
      return {
        isShowTool: false,
        winValue:null,
        winValueTip:null,
      };
    },
    created() {

      if(common_utils.isNull(this.winValueTotal) === false)
      {
        if(this.winValueTotal.length > 1){
          this.winValue = this.winValueTotal[0];
          this.winValueTip = this.winValueTotal[1];
        }
        else
        {
          this.winValue = this.winValueTotal[0];
        }
      }
    },
    methods: {
      getShowTotal()
      {
        if(this.showTotal)
        {
          return Boolean(this.showTotal);
        }
        return false;
      },
      showTool(){
        this.isShowTool = !this.isShowTool;
        console.log("showTool::"+this.showTool)
      },
    }
}
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/slots/layout/slots_win_total_layout.vue